<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs3>
                <v-autocomplete
                    label="Plant"
                    :items="plantData"
                    :value="selectedPlantIDs"
                    @input="handlePlantSelected"
                    multiple
                    clearable
                    item-value="PlantID"
                    item-text="PlantName"
                    hide-details
                    dense
                    outline
                    :read-only="plants.length == 1">
                </v-autocomplete>
            </v-flex>
            <v-flex xs3>
                <DateSelector 
                    :value="selectedFromDate"
                    :clearable="false"
                    :required="true"
                    label="From Date"
                    @input="onFromDateSelected">
                </DateSelector>
            </v-flex>
            <v-flex xs3>
                <DateSelector 
                    :value="selectedToDate"
                    :required="false"
                    label="To Date"
                    @input="onToDateSelected">
                </DateSelector>
            </v-flex>                
        </v-layout>
    </v-container>
</template>

<script>
import UtilService from '@/services/utilService.js';
import { mapState, mapMutations, mapActions } from "vuex";
import DateSelector from '@/components/generic/DateSelector.vue'

export default {
    components: {
        DateSelector
    },
    props: {
    },
    data(){
        return {
        };
    },
    computed: {
        ...mapState("NuPointSprayStore", [
            "plantData",
            "selectedPlantIDs",
            "selectedFromDate",
            "selectedToDate"
        ]),
        plants(){
            return this.plantData.map(x => {
                return {
                    text: x.PlantName,
                    value: x.PlantID
                };
            }).sort(UtilService.sortAscending(x => x.text));
        },
        plantSelected(){
            return this.selectedPlantIDs != null;
        },
        dateFromSelected() {
            return this.selectedFromDate != null;
        }
    },
    methods: {
        ...mapMutations("NuPointSprayStore", [
            "setSelectedPlantIDs",
            "setSelectedFromDate",
            "setSelectedToDate"
        ]),
        ...mapActions("NuPointSprayStore", [
            "searchNuPointSprayJobs",
            "loadPlants",
            "loadLocations"
        ]),
        async handlePlantSelected(value){
            this.setSelectedPlantIDs(value);
            await this.searchNuPointSprayJobs();
        },
        async onFromDateSelected(date) {
            this.setSelectedFromDate(date);

            if (this.selectedFromDate) {
                await this.searchNuPointSprayJobs();
            }
        },
        async onToDateSelected(date) {
            this.setSelectedToDate(date);
            await this.searchNuPointSprayJobs();
        }
    },
    created() {
        this.loadPlants();
        this.loadLocations();
    }
}
</script>